// HomeRow.js
// One row inside a HomeCard: optional tag, optional leading icon, a title +
// subtitle column, and a trailing action (button or a custom node).
import React from "react";
import { View, Text, TouchableOpacity, Pressable, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { HOME, homeColors } from "../homeTheme";
import HomeTag from "./HomeTag";

const renderAction = (action, colors, testID) => {
  if (!action) return null;
  if (action.node) return action.node;
  return (
    <TouchableOpacity
      onPress={action.onPress}
      testID={testID ? `${testID}-action` : undefined}
      accessibilityRole="button"
      accessibilityLabel={action.label}
      style={[
        styles.actionBtn,
        action.primary && { backgroundColor: colors.brand },
      ]}
    >
      <Text
        style={[
          styles.actionLabel,
          { color: action.primary ? "#ffffff" : colors.brand },
        ]}
      >
        {action.label}
      </Text>
    </TouchableOpacity>
  );
};

const HomeRow = ({
  tag = null,
  icon = null,
  title,
  subtitle = null,
  action = null,
  onPress = null,
  isDarkMode = false,
  testID,
  first = false,
}) => {
  const colors = homeColors(isDarkMode);
  const Wrapper = onPress ? Pressable : View;

  return (
    <Wrapper
      testID={testID}
      onPress={onPress || undefined}
      accessibilityRole={onPress ? "button" : undefined}
      accessibilityLabel={onPress ? title : undefined}
      style={[
        styles.row,
        { borderTopWidth: first ? 0 : 1, borderTopColor: colors.line },
      ]}
    >
      {icon ? (
        <MaterialCommunityIcons
          name={icon}
          size={18}
          color={colors.textSecondary}
          style={styles.icon}
        />
      ) : null}
      {tag ? (
        <View style={styles.tagWrap}>
          <HomeTag label={tag.label} tone={tag.tone} isDarkMode={isDarkMode} />
        </View>
      ) : null}
      <View style={styles.textCol}>
        <Text style={[styles.title, { color: colors.textPrimary }]}>{title}</Text>
        {subtitle ? (
          <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
            {subtitle}
          </Text>
        ) : null}
      </View>
      {renderAction(action, colors, testID)}
    </Wrapper>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: HOME.rowPadY,
    gap: 10,
  },
  icon: { marginRight: 2 },
  tagWrap: { marginRight: 2, flexShrink: 1 },
  textCol: { flex: 1 },
  title: { fontSize: HOME.titleSize, fontWeight: "600" },
  subtitle: { fontSize: 13, marginTop: 2 },
  actionBtn: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 8,
  },
  actionLabel: { fontSize: 13, fontWeight: "700" },
});

export default HomeRow;
